<template>
    <div class="daily-goal">
        <!-- 筛选栏 -->
        <div class="filter-bar">
            <span class="filter-label">日期</span>
            <el-date-picker v-model="form.date" type="date" placeholder="选择日期" value-format="YYYY-MM-DD"
                :clearable="false" @change="submit" />
            <template v-if="groups && groups.length">
                <span class="filter-label">组别</span>
                <el-select v-model="form.group" placeholder="选择组别" filterable :clearable="false"
                    style="width: 130px" @change="submit">
                    <el-option v-for="g in groups" :key="g" :label="g" :value="g" />
                </el-select>
            </template>
        </div>

        <!-- 日目标数据表 -->
        <el-card shadow="never" class="daily-goal-card">
            <template #header>
                <span class="card-title">每日目标</span>
            </template>
            <el-table :data="dataDailyGoal.dailyGoalData" style="width: 100%" border size="small"
                show-overflow-tooltip>
                <el-table-column v-for="(item, index) in dataDailyGoal.dailyGoalDataHeader" :key="index"
                    :prop="item.property" :label="item.label" align="center">
                    <template #default="{ row }" v-if="item.type === 'progress'">
                        <div class="goal-bar">
                            <div class="goal-bar-fill" :style="{ width: clampPercent(row[item.property]) + '%' }"></div>
                            <span class="goal-bar-text">{{ row[item.property] }}%</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script>
    export default {
        name: "CatDailyGoal",
        props: {
            dataDailyGoal: {
                type: Object,
                default: () => ({
                    dailyGoalFollowDataHeader: [],
                    dailyGoalDataHeader: [],
                    dailyGoalFollowData: [],
                    dailyGoalData: []
                })
            },
            searchs: {
                type: [Array, Object],
                default: () => ({})
            },
            groups: {
                type: Array,
                default: () => []
            }
        },
        emits: ['update:searchs', 'search'],
        data() {
            return {
                form: {
                    date: '',
                    group: ''
                }
            }
        },
        created() {
            this.syncForm();
        },
        watch: {
            searchs: {
                deep: true,
                handler() {
                    this.syncForm();
                }
            },
            groups: {
                immediate: true,
                handler(v) {
                    if (v && v.length && !this.form.group) {
                        this.form.group = v[0];
                    }
                }
            }
        },
        methods: {
            syncForm() {
                const s = this.searchs && !Array.isArray(this.searchs) ? this.searchs : {};
                this.form.date = s.date || this.currentDate();
                this.form.group = s.group || '';
            },
            currentDate() {
                const d = new Date();
                return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
            },
            submit() {
                this.$emit('update:searchs', { ...this.form });
                this.$emit('search', { ...this.form });
            },
            clampPercent(value) {
                const percent = Number(value);
                if (isNaN(percent)) return 0;
                return percent < 0 ? 0 : (percent > 100 ? 100 : percent);
            }
        }
    }
</script>

<style scoped>
    .filter-bar {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;
        padding: 8px 12px;
        background-color: #fff;
    }

    .filter-label {
        font-size: 13px;
        color: #606266;
    }

    .daily-goal-card {
        margin-bottom: 8px;
    }

    .card-title {
        font-weight: 600;
        font-size: 14px;
    }

    .goal-bar {
        position: relative;
        height: 18px;
        width: 100%;
        background-color: #f0f2f5;
        border-radius: 3px;
        overflow: hidden;
    }

    .goal-bar-fill {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        background: linear-gradient(to right, #409eff, #d9ecff);
    }

    .goal-bar-text {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #303133;
    }
</style>